import React, { FunctionComponent } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { BasicButton } from '../../../../widgets/buttons';
import { Dialog, DialogWindow } from '../../../../widgets/dialog';
import { FormControl } from '../../../../widgets/formControl';
import { ZTooltip } from '../../../../widgets/ztooltip';

const CustomDialogWindow = styled(DialogWindow)`
    max-width: 600px;
    padding-bottom: 40px;

    ${FormControl} {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }
`;

export const SideActionDialog: FunctionComponent<{
    actions: ('image' | 'name' | 'area')[];
    onSelected: (action: 'image' | 'name' | 'area') => void;
}> = ({ actions, onSelected }) => {
    return (
        <Dialog windowDecorator={CustomDialogWindow} buttons={[]}>
            {actions.indexOf('name') != -1 && (
                <FormControl>
                    <BasicButton onClick={() => onSelected('name')}>{T._('Change name', 'Admin')}</BasicButton>
                </FormControl>
            )}
            {actions.indexOf('image') != -1 && (
                <FormControl>
                    <ZTooltip position={'right'} html={<>{T._('We suggest to use images below 2MB to avoid slow loading time of the customizer.', 'Admin')}</>}>
                        <BasicButton onClick={() => onSelected('image')}>{T._('Change image', 'Admin')}</BasicButton>
                    </ZTooltip>
                </FormControl>
            )}
            {actions.indexOf('area') != -1 && (
                <FormControl>
                    <BasicButton onClick={() => onSelected('area')}> {T._('Edit print area', 'Admin')}</BasicButton>
                </FormControl>
            )}
        </Dialog>
    );
};
